export default __webpack_public_path__ + "19702a8c20161c74c799178de3fa7885.svg";